<template>
  <kst-page-list
    :catalog="SearchCatalog"
    :params="searchParams"
    :search="searchData"
    @init="handleInit"
    @load="handleLoad"
    @reset="handleReset"
  >
    <template #search="{ handleInput }">
      <Search
        :searchData="searchData"
        :warehouseOptions="warehouseOptions"
        @input="handleInput"
      />
    </template>

    <template #search-result="{ data }">
      <List
        :access="access"
        :items="data.List"
      />
    </template>
  </kst-page-list>
</template>

<script>
import Model from "../DebtModel.js";
import SearchCatalog from "./SearchCatalog.js";
import Services from "../../../services/Api/DebtServices.js";

import List from "./DebtL_List.vue";
import Search from "./DebtL_Search.vue";

export default {
  components: {
    List,
    Search
  },
  data: () => ({
    SearchCatalog: SearchCatalog,
    access: {},
    searchData: {
      Search: "",
      VendorID: null,
      VendorName: "",
      Date: null,
      WarehouseID: null
    },
    searchParams: ["Search", "VendorID", "VendorName", "Date", "WarehouseID"],
    warehouseOptions: {}
  }),
  created() {
    this.resetSearch();
  },
  methods: {
    handleInit(loadListData) {
      this.resetData();

      const options = this.getListOptions();
      const config = Services.getListData(options); 
      loadListData(config, this.handleInit_Success);
    },
    handleInit_Success(data) {
      if (this.searchData.VendorID !== null) {
        this.searchData.VendorName = this.$kst.In.getString(
          data.Search.VendorName
        );
      }

      this.warehouseOptions = Model.getWarehouseOptions(
        data.WarehouseList, SearchCatalog.WarehouseID.Label
      );
    },

    handleLoad(loadList) {
      const options = this.getListOptions();
      const config = Services.getList(options);
      loadList(config);
    },
    handleReset() {
      this.resetSearch();
    },

    resetData() {
      this.access = this.$kst.Access.create(Model.Access);
      this.warehouseOptions = {};

      this.normalizeSearch();
    },
    normalizeSearch() {
      if (this.searchData.WarehouseID === null) {
        this.searchData.WarehouseID = this.$kst.Session.getDefaultWarehouseID();
      }
    },
    resetSearch() {
      this.searchData.Search = "";
      this.searchData.VendorID = null;
      this.searchData.VendorName = "";
      this.searchData.Date = this.$kst.In.getDefaultDateRange();
      this.searchData.WarehouseID = this.$kst.Session.getDefaultWarehouseID();
    },
    getListOptions() {
      const vendorId = this.$kst.Out.getInteger(this.searchData.VendorID);
      const vendorName = vendorId === null
        ? this.$kst.Out.getString(this.searchData.VendorName) : null;

      return {
        startdate: this.$kst.Out.getDateString(this.searchData.Date[0]),
        enddate: this.$kst.Out.getDateString(this.searchData.Date[1]),
        vendor: vendorId,
        vendorname: vendorName,
        warehouse: this.$kst.Search.getValue(this.searchData.WarehouseID),
        search: this.$kst.Out.getString(this.searchData.Search),
        field: Model.Search.Fields
      };
    }
  }
}
</script>